// 常量

// 房间类型
export enum ROOM_TYPE {
  AUDIO_LIVE = 3, // 音频直播
  VIDEO_LIVE = 6, // 视频直播
  VIDEO_CALL = 10, // 视频通话
  VIDEO_CALL_SHORT = 30 // 短视频通话
}

/**
 * 消息类型
 */
export enum ROOM_CHAT_TYPE {
  CHAT_TEXT = 1, // 会话文本
  ENTER_ROOM = 2, // 成员进房
  PROMPT_TEXT = 3, // 纯文本提示消息
  GAME = 4, // 游戏消息
  CHAT_GIFT = 5, // 会话礼物 cocco
  EMOJI_RESULT = 6, // 表情结果消息 cocco
  ROOM_UPDATE = 7, // 房间更新通知 cocco
  /** 幸运返利 */
  LUCK_REBATE = 8,
  /** html本提示消息 */
  PROMPT_HTML = 9,
  /** CP上麦 */
  CP_MIC = 10
}

// VIP颜色 5个级别
const VIP_COLOR = {
  1: '#B88357',
  2: '#46BA65',
  3: '#3229D6',
  4: '#8728DA',
  5: '#DB3801'
}

export default {
  ROOM_TYPE,
  ROOM_CHAT_TYPE,
  VIP_COLOR
}
